import { CancelToken } from "axios";
import { getIn, setIn, useFormikContext } from "formik";
import { FC } from "react";
import { InputContainer, InputRow } from "../../../styles/form";
import FormError from "../form/FormError";
import { InputLabel, InputTextAfter } from "../form/InputStyles";
import RequiredMark from "../form/RequiredMark";
import Suggestion, { ISuggestionValue } from "./Suggestion";

interface IProps {
  nameId: string;
  nameText: string;
  label?: string;
  textAfter?: string | JSX.Element;
  tooltipLeft?: boolean;
  showListAlways?: boolean;
  disabled?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
  loadSuggestions(
    text: string,
    cancelToken: CancelToken,
    size?: number
  ): Promise<ISuggestionValue[]>;
}

const SuggestionFormik: FC<IProps> = ({
  nameId,
  nameText,
  label,
  textAfter,
  tooltipLeft,
  showListAlways,
  disabled,
  placeholder,
  autoFocus,
  loadSuggestions,
}) => {
  const {
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
    validateForm,
  } = useFormikContext<any>();

  const fieldValue = getIn(values, nameId);
  const fieldText = getIn(values, nameText);
  const fieldError = getIn(errors, nameId);
  const fieldTouched = getIn(touched, nameId);

  const handleSelectValue = (value: ISuggestionValue | undefined) => {
    const nextId = value?.id;
    const nextText = value?.text;

    setFieldValue(nameId, nextId, true);
    setFieldValue(nameText, nextText, true);
    validateForm(setIn(setIn(values, nameId, nextId), nameText, nextText));
  };

  const handleBlur = () => {
    setFieldTouched(nameId, true, true);
  };

  const error = !!fieldTouched && !!fieldError;
  const selected = fieldValue
    ? {
        id: fieldValue,
        text: fieldText,
      }
    : undefined;

  return (
    <InputRow>
      {label && (
        <InputLabel htmlFor={nameId}>
          {label}
          {fieldError && <RequiredMark />}
        </InputLabel>
      )}
      <InputContainer>
        <Suggestion
          id={nameId}
          selected={selected}
          error={error}
          showListAlways={showListAlways}
          disabled={disabled}
          disabledBySelected={!!selected?.id}
          placeholder={placeholder}
          autoFocus={autoFocus}
          loadSuggestions={loadSuggestions}
          selectValue={handleSelectValue}
          onBlur={handleBlur}
        />
        {textAfter && <InputTextAfter>{textAfter}</InputTextAfter>}
        {error && <FormError name={nameId} tooltipLeft={tooltipLeft} />}
      </InputContainer>
    </InputRow>
  );
};

export default SuggestionFormik;
